<template>
    <pendo-drawer
        :visible="visible"
        class-name="voc-feedback-form-drawer"
        placement="bottom"
        size="fullscreen"
        title="Submit feedback"
        :z-index="2000"
        @closed="$emit('closed')">
        <template #body>
            <voc-feedback-form
                v-if="visible"
                ref="feedbackForm"
                v-model="feedbackFormStatus"
                :drawer="true"
                :query="query"
                @closed="$emit('closed', $event)" />
        </template>
        <template #footer="{ close }">
            <div class="voc-feedback-form-drawer-footer">
                <pendo-button
                    data-cy="voc-feedback-form-cancel-button"
                    type="secondary"
                    label="Cancel"
                    @click="close" />
                <pendo-button
                    v-if="!feedbackFormStatus.feedbackSubmitted"
                    :disabled="!feedbackFormStatus.isFormValid"
                    data-cy="voc-feedback-form-submit-button"
                    type="primary"
                    label="Submit feedback"
                    :loading="feedbackFormStatus.saving"
                    @click="submitForm" />
            </div>
        </template>
    </pendo-drawer>
</template>

<script>
import { EventBus } from '@utils/event-bus.js';
import { PendoDrawer, PendoButton } from '@pendo/components';
import VocFeedbackForm from '@/voc/components/voc-feedback-form/voc-feedback-form.vue';

export default {
    components: {
        PendoDrawer,
        PendoButton,
        VocFeedbackForm,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        query: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['closed'],
    data () {
        return {
            feedbackFormStatus: {
                isFormValid: false,
                saving: false,
                feedbackSubmitted: false,
            },
        };
    },
    mounted () {
        window.addEventListener('popstate', this.handlePopState);
    },
    beforeUnmount () {
        window.removeEventListener('popstate', this.handlePopState);
    },
    methods: {
        async submitForm () {
            await this.$refs.feedbackForm.submitForm();
            EventBus.$emit('discoverFeedbackDataChanged');
        },
        handlePopState () {
            if (this.visible) {
                this.$emit('closed');
            }
        },
    },
};
</script>

<!-- eslint-disable-next-line vue-scoped-css/enforce-style-type -->
<style lang="less">
.voc-feedback-form-drawer {
    .pendo-drawer__body {
        padding: 0;
    }

    &-footer {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
